import { ViewProperties } from "../../../utils/ViewProperties";
/**
 * Game-specific properties for the top bar.
 */
export class GameTopBarProperties extends ViewProperties {
}
//# sourceMappingURL=GameTopBarProperties.js.map